module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal__and__left_indent"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("SEPT JOURS")]), _vm._v(" avant Noël, Ben Walsh quitta son bureau au centre de Manhattan et commença le long parcours qui le ramenait de la 44e rue jusqu’à son appartement, situé dans le quartier Hell’s Kitchen – autrement dit, la ‘cuisine de l’enfer’, à Manhattan, New York. Il passa devant le théâtre St James, où, depuis le printemps dernier, se jouait la comédie musicale "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("American Idiot")]), _vm._v(". Une queue commençait à se former pour la représentation de ce jeudi soir. Quant à Ben, il réfléchissait à son dernier dilemme.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Plus qu’une semaine avant Noël et il n’avait toujours pas de cadeau pour David, son compagnon depuis sept semaines, un homme sensuel et amusant qui s’entendait très bien avec tous ses amis. Ben n’avait rien à lui reprocher, alors pourquoi ne réussissait-il pas à trouver un cadeau à lui offrir ?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Une fois de plus, Ben s’était attardé au bureau. Il travaillait chez Wilson & Mead, l’un des meilleurs cabinets juridiques de la ville. Lorsque son iPhone vibra dans la poche de son pantalon, il le sortit pour vérifier. Il s’agissait d’un message de Colin. Ben essuya l’écran pour le lire.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rendez-vous chez M & J. 20 h. Viens avec David.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Il regarda sa montre. Dix-neuf heures trente. Il n’avait pas encore appelé David. Même si tous deux passaient presque toutes leurs soirées ensemble depuis Thanksgiving, Ben n’avait pas voulu tenir sa présence pour acquise. Il pressa une touche de son téléphone, David répondit après quelques sonneries.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Hey, tombeur. Je pensais justement à toi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Ben sourit en entendant sa voix basse et profonde. Tout en zigzaguant parmi la file d’attente, il passa les doigts dans ses cheveux noirs.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— C’est vrai ? répondit-il. J’espère qu’il s’agissait de pensées érotiques.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("En partie.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("David avait trente-huit ans, soit une dizaine d’années de plus que lui. Ancien militaire et actuel pilote de ligne, il possédait une virilité naturelle que tout le monde, y compris Ben, trouvait attirante.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Eh bien, nous sommes convoqués ce soir chez Martin et Johnny pour une soirée de Noël.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Tes amis ne sont-ils jamais capables de planifier ?")]), _vm._v(" lui demanda David, d’un ton moqueur.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Non, jamais. Désolé. Je pense qu’ils veulent marquer le coup avec un peu d’avance. C’est mon dernier week-end en ville avant que je rentre chez moi.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Chez toi ? Ah, tu veux dire que tu retournes au Texas. Mais tu seras revenu pour le nouvel an, non ? Je veux accueillir 2011 avec toi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Ouais, je serai là. Alors, tu es d’accord pour une petite réunion impromptue ce soir ?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Bien sûr. Tout à fait d’accord.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Génial.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("David agissait comme tous ceux qui, au début d’une relation, n’osent jamais dire : ‘"), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Écoute, je suis crevé, je n’ai vraiment pas envie de voir tes amis ce soir")]), _vm._v(".’ Ben s’arrêta au coin de la 8e avenue. Une anomalie l’alerta. Levant les yeux, il vit que les feux de circulation ne fonctionnaient pas.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Le feu orange passa au vert.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Attention. C’est bon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Au lieu de passer du orange au rouge.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Attention. Stop.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Pourquoi l’ordre des feux était-il inversé ? Ben descendit du trottoir, mais il recula aussitôt, effrayé.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Hé, Ben, tu es toujours là ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Zut, David venait de lui poser une question. Ben releva les yeux. Les feux fonctionnaient normalement, il traversa donc la rue.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Ouais. Désolé, j’ai été distrait par la foule des fans de Green Day. Tu me demandais quoi ?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Tu veux passer d’abord ici ou tu préfères que nous nous retrouvions là-bas ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Allons directement chez Martin et Johnny. J’ai reçu un message de Colin, ils nous attendent à 20 heures et je serai en retard, de toute façon.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Pas de souci. À tout à l’heure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— D’accord, merci. À très vite.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Ben appuya sur le bouton rouge de son écran pour couper la communication, puis il rangea son téléphone dans sa poche. En approchant de l’Hudson, il sentit le vent d’hiver devenir plus violent et balayer la rue. Il releva les épaules vers ses oreilles pour tenter d’avoir plus chaud, mais en vain. Il leva la tête et vit le ciel prendre des teintes pourpres. Ceci annonçait-il la neige ? Tout à coup, il ressentit la même sensation que précédemment : une anomalie. Il vérifia les feux en atteignant la 9e avenue. Tout semblait normal. Il déglutit, la bouche sèche. Il fouilla dans son sac de sport pour en sortir une bouteille entamée de boisson énergisante dont il but une gorgée.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Son portable recommença à vibrer. Sans doute encore Colin pour lui demander où il était. Ben sortit son appareil et regarda l’écran. Un numéro commençant par 512, donc d’Austin, mais Ben ne le reconnut pas. Il répondit immédiatement.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Ben Walsh, annonça-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Il prit une autre gorgée de sa bouteille avant de la ranger dans son sac. Le vent soufflait plus fort encore.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Bonjour, Ben. Je suis le père Davenport. Nous ne nous sommes jamais rencontrés, mais je suis le nouveau prêtre du Centre catholique universitaire. Je me trouve à l’hôpital Seton.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Ben était au beau milieu du carrefour, il pressa un doigt contre son oreille gauche pour mieux entendre.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Oui ?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Ben, il y a eu un accident.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— Quel accident ?")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Vos parents. Ils rentraient chez eux quand ils ont été heurtés, sur l’autoroute, par un jeune… Eh bien, je ne vois aucun n moyen de vous l’annoncer en douceur. Les médecins ont fait tout ce qu’ils pouvaient, mais… c’était trop tard. Ils sont décédés, Ben. Je suis désolé, mais vous venez de perdre vos parents. Vous devriez prendre le prochain avion pour rentrer. Vos frères ont besoin de vous.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Les bruits urbains disparurent dans un silence caverneux. Ben leva les yeux. Les feux fonctionnaient à l’envers, une fois de plus. Il entendit une voix dans sa tête, celle de son père, qui lui chantait une chanson datant de son enfance. Les Eagles, peut-être ? Oui, il en était presque certain. "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Une journée à New York")]), _vm._v(". Voilà le nom de la chanson.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Il sentit le sang lui monter au visage, il eut du mal à respirer. Il eut la sensation que le sol s’agitait sous ses pieds, même s’il était toujours planté sur le trottoir, tétanisé. Bientôt, il saurait quoi faire, qui appeler, où aller. Ou peut-être qu’il se réveillerait pour découvrir que le père Davenport n’était que le fruit de son imagination, un atroce cauchemar. Un flocon de neige tomba du ciel en tourbillonnant pour atterrir sur son nez. Il fut suivi par un autre, puis trois, dix, dix mille, jusqu’à ce qu’une tempête de neige engloutisse Ben et le gèle jusqu’à l’os. Au milieu de cette tourmente blanche, il entendait toujours la voix désincarnée du père Davenport qui le mitraillait de questions à travers le petit haut-parleur de son portable.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("— "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Ben ? Vous êtes toujours là ? Vous m’entendez ? Ben ? Ben ?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01997e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section-0004.vue
// module id = 66
// module chunks = 0